import { render } from "./AlgorithmView.vue?vue&type=template&id=75636394"
import script from "./AlgorithmView.vue?vue&type=script&lang=js"
export * from "./AlgorithmView.vue?vue&type=script&lang=js"

import "./AlgorithmView.vue?vue&type=style&index=0&id=75636394&lang=scss"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__